const SURVEY_ACTIVE_COUNT_KEY = "bhp:survey_active_count";
const SURVEY_ACTIVITY_EVENT = "bhp:survey-activity-changed";

const readActiveCount = () => {
  try {
    const raw = sessionStorage.getItem(SURVEY_ACTIVE_COUNT_KEY);
    const value = Number(raw || 0);
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
};

const writeActiveCount = (count) => {
  try {
    if (count > 0) {
      sessionStorage.setItem(SURVEY_ACTIVE_COUNT_KEY, String(count));
    } else {
      sessionStorage.removeItem(SURVEY_ACTIVE_COUNT_KEY);
    }
  } catch {}
};

const dispatchSurveyActivity = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(SURVEY_ACTIVITY_EVENT, {
      detail: { active: isSurveyActive() },
    }),
  );
};

export const isSurveyActive = () => readActiveCount() > 0;

export const markSurveyActive = () => {
  writeActiveCount(readActiveCount() + 1);
  dispatchSurveyActivity();
};

export const clearSurveyActive = () => {
  writeActiveCount(Math.max(0, readActiveCount() - 1));
  dispatchSurveyActivity();
};

export const getSurveyActivityEventName = () => SURVEY_ACTIVITY_EVENT;
